<div [formGroup]="personalInfoForm" class="row form-wrapper custom-form-wrapper">
    <div class="col-12">
      <app-input-form-field
        formControlName="department"
        [label]="'label.department' | translate"
        [placeholder]="'--'"
        [translatable]="false"
      ></app-input-form-field>
    </div>
    <div class="col-12">
      <app-input-form-field
        formControlName="email"
        [label]="'label.email' | translate"
        [placeholder]="'--'"
        [translatable]="false"
      ></app-input-form-field>
    </div>
    <div class="col-12">
      <app-input-form-field
        formControlName="contactPhone"
        [label]="'label.contact_phone' | translate"
        [placeholder]="'--'"
        [translatable]="false"
      ></app-input-form-field>
    </div>
    <div class="col-12">
      <app-configuration-select-form-field
        formControlName="globalCustomerName"
        [label]="'case.fields.globalCustomerName.label' | translate"
        [helpText]="'case.fields.globalCustomerName.help'"
        [placeholder]="'placeholders.please_select'"
        [clearable]="true"
        [searchable]="true"
        [viewMode]="false"
        [externalSearch]="true"
        [params]="{
          type: dropdownGlobalCustomers,
          entry1: '',
          entry2: '',
          entry3: '',
          entry4: '',
          entry5: personalInfoForm.get('globalCustomerName')?.value || ''
        }"
        [entry]="'entry5'"
      ></app-configuration-select-form-field>
    </div>
</div>
